import RightUpArrow from '../assets/icons/right-up-arrow.svg'

function ClassDetailTabFloatingButton({ editState }) {
  return (
    <div className='button_solid_primary_lg fixed bottom-[50px] left-1/2 z-[500] min-w-max -translate-x-1/2 gap-6 shadow-strong'>
      <p className='shrink-0'>{`${editState ? '수정중인 카드 위치로 이동' : '다음 차시 카드 위치로 이동'}`}</p>
      <img src={RightUpArrow} alt='' />
    </div>
  )
}

function ClassDetailEditFloatingButton() {
  return (
    <div className='fixed bottom-[50px] left-[calc(50%-385px)] z-[500] flex w-[770px] items-center justify-between rounded-8 bg-background-default px-20 py-12 shadow-strong'>
      <p className='shrink-0 text-body1-regular text-label-default'>
        변경 사항을 저장하려면 수정 완료 버튼을 눌러주세요!
      </p>
      <div className='flex items-center gap-8 shrink-0'>
        <button className='button_outlined_assistive_sm'>되돌리기</button>
        <button className='button_solid_primary_sm'>수정 완료</button>
      </div>
    </div>
  )
}

export { ClassDetailTabFloatingButton, ClassDetailEditFloatingButton }
